<template>
  <div>
    <!-- <landingBanner/> -->
    <section class="section-banner">
      <Slick ref="cinemaSlick" :options="landingBanner">
        <div>
          <div class="cinema-bannerContainer">
            <img
              v-if="
                this.cinemasList.length > 0 &&
                  this.cinemasList[0].organization_card_img != ''
              "
              :src="this.cinemasList[0].organization_card_img"
              class="img-fluid"
              alt
            />
            <img
              v-else-if="project == 'wanasatime'"
              src="@/assets/img/1920-x-600.jpg"
              class="img-fluid"
              alt
            />
            <img
              v-else-if="project == 'ticketak'"
              src="@/assets/img/ticketak_banner1.jpg"
              class="img-fluid"
              alt
            />

            <!-- <div class="filterbox"> -->
            <div class="bannerContent">
              <div class="w-75 pr-2">
                <!-- <div class="bannerTitle">{{org.organizationName}}</div> -->
                <div class="details">
                  <!-- <span>{{org.organizationDescription}}</span> -->
                </div>
              </div>
              <div class="w-25"></div>
            </div>
            <!-- </div> -->
          </div>
        </div>
      </Slick>
    </section>
    <div class="wrapper pt-0">
      <div class="border-bottom pb-1 my-4">
        <div class="section-title">Cinemas1</div>
      </div>

      <!-- <div class="section-space"></div> -->
      <div class="row">
        <div class="col-md-3 col-lg-3 col-xl-2 d-none d-md-block">
          <div class="filter-sticky">
            <div class="accordian-container" :key="accordian">
              <button v-b-toggle.cinemas class="btn-accordian">
                <img
                  src="@/assets/img/icon-cinema.png"
                  height="auto"
                  width="20px"
                  alt="Cinema-icon"
                />
                Cinemas
              </button>
              <b-collapse class="btn-accordian-content" id="cinemas">
                <!-- <button class="btn-accordian-child" v-on:click="onClickCinemaNameAll()">All Cinemas</button> -->
                <!-- <button
                  :class="cinemaName == 'star' ? 'active':''"
                  class="btn-accordian-child"
                  v-on:click="onClickCinemaNameFilter('star')"
                >Star Cinemas</button>
                <button
                  class="btn-accordian-child"
                  :class="cinemaName == 'akil' ? 'active':''"
                  v-on:click="onClickCinemaNameFilter('akil')"
                >Cinema Akil</button>
                <button
                  class="btn-accordian-child"
                  :class="cinemaName == 'oscar' ? 'active':''"
                  v-on:click="onClickCinemaNameFilter('oscar')"
                >Oscar Cinemas</button>-->
                <button
                  v-on:click="onClickCinemaNameFilter(cinema.organizationID)"
                  class="btn-accordian-child"
                  v-for="(cinema, cinemakey) in OrganizationList"
                  :key="cinemakey"
                >
                  {{ cinema.organizationName }}
                </button>
              </b-collapse>
            </div>
            <!-- CINEMA FILTER -->
            <!-- ALL LOCATIONS FILTER -->
            <div class="accordian-container d-none">
              <button v-b-toggle.locations class="btn-accordian">
                <img
                  src="@/assets/img/svg/icon-world.svg"
                  height="18px"
                  width="18px"
                  alt
                />
                {{ dropDowns.locations.selected.Title }}
              </button>
              <b-collapse class="btn-accordian-content" id="locations">
                <button
                  v-b-toggle.locations
                  v-for="(location, locationListIndex) in dropDowns.locations
                    .list"
                  :key="locationListIndex"
                  class="btn-accordian-child"
                  v-on:click="filterData(location, 'location')"
                >
                  {{ location.Title }}
                </button>
              </b-collapse>
            </div>
          </div>
        </div>

        <div class="col-md-9 col-lg-9 col-xl-10">
          <div v-if="cinemasList.length > 0" class="row cinema-listing">
            <div
              class="col-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 mb-4"
              v-for="(cinemaItem, cinemaListingKey) in cinemasList"
              :key="cinemaListingKey"
            >
              <router-link
                :to="{
                  name: 'cinemaDetails',
                  params: { cinemaId: cinemaItem['id'] }
                }"
              >
                <div class="cinema-card">
                  <img
                    v-if="cinemaItem.cinema_card_img.includes('assets/images')"
                    :src="cinemaItem.cinema_card_img"
                    class="movie-poster"
                    alt
                  />
                  <img
                    v-else
                    src="@/assets/img/app_logo_single.png"
                    class="movie-poster"
                    alt
                  />
                  <!-- <img src="@/assets/img/alita325.jpg" class="cinema-poster" alt="CinemaLogo"> -->
                  <div class="cinema-content">
                    <div class="cinema-name">{{ cinemaItem.title }}</div>
                    <!-- <p class="cinema-desc">{{cinemaItem.desc}}</p> -->
                  </div>
                </div>
              </router-link>
            </div>
          </div>
          <div v-else>No Cinemas Found</div>
        </div>
      </div>
    </div>

    <!-- FIXED BOTTOM FILTER BUTTON -->
    <!-- <section class="fixed-filter d-md-none">
      <button v-b-modal.quickBook-modal class="btn-filter-quickbook">Quick Book</button>
      <button v-on:click="filterModal = !filterModal" class="btn-filter">Filter</button>
    </section>-->

    <!-- FILTER MODAL START-->
    <section v-if="filterModal" class="filter-modal">
      <div class="filter-modalContent">
        <nav>
          <img
            src="@/assets/img/svg/arrow-left.svg"
            height="20px"
            width="20px"
            alt="Back"
            v-on:click="filterModal = !filterModal"
          />
          <h6>Filter</h6>
          <a class="btn-reset">RESET</a>
        </nav>

        <div class="text-muted mb-3">S0RT BY</div>

        <!-- TODAY FILTER -->
        <div>
          <button class="btn-filterCollapse no-focus" v-b-toggle.today>
            <img
              src="@/assets/img/svg/icon-map.svg"
              height="15px"
              width="15px"
            />
            Today, FRI 15
          </button>
          <b-collapse id="today">
            <ul class="filter-list">
              <li v-for="(filterList, filterListKey) in 5" :key="filterListKey">
                <label for="date">Movie Date</label>
                <input id="date" type="checkbox" />
              </li>
            </ul>
          </b-collapse>
        </div>

        <hr />

        <!-- LOCATION FILTER -->
        <div>
          <button class="btn-filterCollapse no-focus" v-b-toggle.locationFilter>
            <img
              src="@/assets/img/svg/icon-map.svg"
              height="15px"
              width="15px"
            />
            Location
          </button>

          <b-collapse id="locationFilter">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquam
              eius hic facilis, suscipit in magnam ratione? Rem neque debitis
              dolore id. Voluptatem qui non delectus, rerum eaque doloremque
              quibusdam veniam.
            </p>
          </b-collapse>
        </div>

        <hr />

        <!-- CINEMA FILTER -->
        <div>
          <button class="btn-filterCollapse no-focus" v-b-toggle.cinemaFilter>
            <img
              src="@/assets/img/svg/icon-map.svg"
              height="15px"
              width="15px"
            />
            Cinema
          </button>
          <b-collapse id="cinemaFilter">
            <ul class="filter-list">
              <li v-for="(filterList, filterListKey) in 5" :key="filterListKey">
                <label for="cinema">Cinema</label>
                <input id="cinema" type="checkbox" />
              </li>
            </ul>
          </b-collapse>
        </div>

        <hr />

        <!-- LANGUAGE FILTER -->
        <div>
          <button class="btn-filterCollapse no-focus" v-b-toggle.languageFilter>
            Language
          </button>
          <b-collapse id="languageFilter">
            <ul class="filter-list">
              <li v-for="(filterList, filterListKey) in 5" :key="filterListKey">
                <label for="lang">English</label>
                <input id="lang" type="checkbox" />
              </li>
            </ul>
          </b-collapse>
        </div>

        <hr />

        <!-- TYPE FILTER -->
        <div class="mb-5">
          <button class="btn-filterCollapse no-focus" v-b-toggle.typeFilter>
            Type
          </button>
          <b-collapse id="typeFilter">
            <ul class="filter-list">
              <li v-for="(filterList, filterListKey) in 5" :key="filterListKey">
                <label for="type">Movie Type</label>
                <input id="type" type="checkbox" />
              </li>
            </ul>
          </b-collapse>
        </div>

        <div class="btn-container">
          <button class="btn-applyFilter no-focus">APPLY FILTER</button>
        </div>
      </div>
    </section>
    <!-- FILTER MODAL ENDS -->
  </div>
</template>

<script>
import QuickBook from "@/components/partials/QuickBook.vue";
import { makeRequest } from "@/helper/internet.js";
import landingBanner from "@/components/partials/mainBanner";
import Slick from "vue-slick";
import { uniqBy, filter } from "lodash";
import {
  PROJECT,
  METAWEBSITE,
  METAORGANIZATION,
  metaInfo
} from "@/helper/constant.js";

export default {
  name: "CinemaNameisting",
  components: {
    QuickBook,
    landingBanner,

    Slick
  },
  metaInfo: metaInfo,
  data() {
    return {
      project: PROJECT,
      metaWebsite: METAWEBSITE,
      metaOrganization: METAORGANIZATION,
      filterModal: false,
      cinemaSlider: {
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "8%",
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
              arrows: false,
              centerPadding: "0%",
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      landingBanner: {
        initialSlide: 0,
        dots: true,
        arrows: true,
        autoplay: true,
        loop: true,
        infinite: true,
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
        autoplaySpeed: 3500,
        centerPadding: "5%",
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              centerMode: false
            }
          }
        ]
      },
      dropDowns: {
        locations: {
          selected: {
            Title: "All Locations"
          },
          list: []
        }
      },
      cinemasList: [],
      OrganizationList: [],
      cinemasListCopy: [],
      cinemaFilterList: [],
      cinemaName: ""
    };
  },
  beforeMount() {
    this.cinemaName = this.$route.params.cinemaName;
    // this.fetchCinemasList();
    this.GetAllShows();
    this.getAllFilters();
  },
  mounted() {
    this.cinemaName = this.$route.params.cinemaName;
    // this.fetchCinemasList();
    this.GetAllShows();
    this.getAllFilters();
  },
  watch: {
    $route(to, from) {
      this.fetchCinemasList();
      this.cinemaName = this.$route.params.cinemaName;
    }
  },
  methods: {
    filterData: function(data, filter) {
      if (filter == "location") {
        this.dropDowns.locations.selected = data;
      }

      this.GetAllShows();
    },
    onClickCinemaNameFilter: function(cinema) {
      this.$router.push({
        name: "cinemaNameListing",
        params: { cinemaName: cinema }
      });
      this.GetAllShows();
    },
    onClickCinemaNameAll() {
      this.cinemasList = this.cinemasListCopy;
    },
    onClickCinemaName: function(params) {
      this.cinemasList = this.cinemasListCopy.filter(x => {
        if (x.CinemaName == params.CinemaName) {
          return x;
        }
      });
    },
    GetAllShows: function() {
      let payload = {};
      if (this.dropDowns.locations.selected.Title != "All Locations") {
        payload.LocationID = this.dropDowns.locations.selected.LocationID;
      }
      makeRequest("/GetAllShow", "POST", null, payload)
        .then(result => {
          this.OrganizationList = result.res.data.Cinemas;
          this.OrganizationList = uniqBy(
            this.OrganizationList,
            "organizationID"
          );
          this.cinemasList = result.res.data.Cinemas;
          this.cinemasList = this.cinemasList.filter(x => {
            // if (x.organizationID == this.cinemaName) {
            //   return x;
            // }
            if (x.org_slug == this.cinemaName) {
              return x;
            }
          });

          this.cinemaFilterList = this.cinemasList;
          this.cinemasListCopy = this.cinemasList;
          //console.log(this.cinemasList[0].organization_card_img);
          // this.$refs.cinemaSlick.destroy();
          // this.$nextTick(() => {
          //   this.$refs.cinemaSlick.create();
          //   this.$refs.cinemaSlick.goTo(1, true);
          // });
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    getAllFilters: function() {
      makeRequest("/GetAllFilter", "POST", null, null)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            this.dropDowns.locations.list = res.data.List.Locations;
            this.dropDowns.locations.list.push({
              Title: "All Locations"
            });
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    fetchCinemasList: function() {
      makeRequest("/GetAllCinemasList", "POST", null, null)
        .then(result => {
          this.cinemasList = result.res.data.Data;

          this.cinemasList = this.cinemasList.filter(x => {
            if (x.CinemaName.toLowerCase().includes(this.cinemaName)) {
              return x;
            }
          });

          this.cinemaFilterList = this.cinemasList;
          this.cinemasListCopy = this.cinemasList;
          // this.$refs.cinemaSlick.destroy();
          // this.$nextTick(() => {
          //   this.$refs.cinemaSlick.create();
          //   this.$refs.cinemaSlick.goTo(1, true);
          // });
        })
        .catch(error => {
          console.log("Error", error);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/cinemaNameListing.vue